import { faEllipsis } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { use, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import usePrivileges from "../../../../../Auth/usePrivileges";
import { LotDetailContext } from "../../../../../Contexts/LotDetailContext";
import EditHeaderTextDialog from "../../../../../Dialogs/EditHeaderTextDialog";

export function HeaderTextField() {
    const { t } = useTranslation();
    const {
        lotDetail: {
            summary: {
                businessUnitCode,
                data: {
                    headerText
                }
            }
        },
    } = use(LotDetailContext);
    const [showEditHeaderTextDialog, setShowEditHeaderTextDialog] = useState(false);
    const { canReview, canGrade, admin } = usePrivileges(businessUnitCode);

    return (
        <Form.Group as={Col} sm={6} controlId="formHeaderTextCode">
            <Row>
                <Form.Label column sm={4}>{t('LotDetails.Summary.HeaderText')}:</Form.Label>
                <Col sm={8}>
                    <div className="d-flex justify-content-start">
                        <Form.Control type="text" disabled value={headerText ?? ""} />
                        <Button variant="light" hidden={!admin && !canGrade && !canReview} className="ms-2" onClick={() => setShowEditHeaderTextDialog(true)} >
                            <FontAwesomeIcon icon={faEllipsis} />
                        </Button>
                    </div>
                </Col>
            </Row>
            <EditHeaderTextDialog showDialog={showEditHeaderTextDialog} closeDialog={() => setShowEditHeaderTextDialog(false)} />
        </Form.Group>
    );
}